import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {LogotypeView} from '@fantasmagames/slot/src/modules/logotype/LogotypeView';
import {LogotypeViewEvents} from '@fantasmagames/slot/src/modules/logotype/LogotypeViewEvents';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';

export class LogotypeModule extends Module<LogotypeView> {
	protected setupStates(): void {}

	protected enterFirstState(): void {}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.LOGOTYPE_VIEW_MOBILE);
		} else {
			this.setView(Views.LOGOTYPE_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		if (!__PRODUCTION__) {
			this.onViewEmitEvent(LogotypeView.LOGOTYPE_DOUBLE_TAPPED, LogotypeViewEvents.LOGOTYPE_DOUBLE_TAPPED);
		}

		this.on(StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
		this.on(StartScreenEvents.EXIT_FINISHED, this.onStartScreenIntroFinished);
	}

	protected onStartScreenIntroStarted(): void {
		this.view.hide();
	}

	protected onStartScreenIntroFinished(): void {
		this.view.show();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/logotype/LogotypeModule.ts